<template>
  <div class="login-page d-flex align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <div class="section-card p-4 p-lg-5">
            <div class="text-center mb-4">
              <img src="../assets/logo.svg" alt="Nihon Water Maintenance" class="login-logo mb-3">
              <h1 class="h3 font-weight-bold text-primary">Đăng nhập CMS</h1>
              <p class="text-muted mb-0">Quản trị bài viết, banner, thông tin công ty và liên hệ.</p>
            </div>
            <b-form @submit.prevent="handleLogin">
              <b-form-group label="Username">
                <b-form-input v-model.trim="form.username" required />
              </b-form-group>
              <b-form-group label="Password">
                <b-form-input v-model="form.password" type="password" required />
              </b-form-group>
              <b-button type="submit" variant="primary" block pill :disabled="loading">
                {{ loading ? "Đang đăng nhập..." : "Đăng nhập" }}
              </b-button>
            </b-form>
            <!-- <div class="alert alert-info mt-4 mb-0">
              Tài khoản seed mặc định: <strong>admin</strong> / <strong>admin123</strong>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "../api/admin";
import { setAuthToken } from "../utils/auth";

export default {
  name: "AdminLoginView",
  data: function data() {
    return {
      loading: false,
      form: {
        username: "admin",
        password: "admin123"
      }
    };
  },
  methods: {
    async handleLogin() {
      this.loading = true;

      try {
        const response = await login(this.form);
        setAuthToken(response.data.token);
        this.$router.push({ name: "admin-dashboard" });
      } catch (error) {
        this.$bvToast.toast(
          (error.response && error.response.data && error.response.data.message) ||
            "Đăng nhập thất bại.",
          {
            variant: "danger",
            solid: true
          }
        );
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background:
    radial-gradient(circle at top right, rgba(0, 191, 255, 0.25), transparent 30%),
    linear-gradient(180deg, #f7fdff 0%, #eaf9ff 100%);
}

.login-logo {
  width: 84px;
  height: 84px;
  border-radius: 24px;
  object-fit: cover;
}
</style>
